<script lang="ts" setup>
	import AvailabilityTableHeader from '@/components/table/availabilitytable/AvailabilityTableHeader.vue';
	import FixedTableHeader from '@/components/table/fixedtableheader/FixedTableHeader.vue';
	import type {StaticTableHeader, TableSort} from '@/types/table';
	import {useAppStore} from '@/store/app.store';
	import {useFilters} from '@/store/filter.store';
	import {setSelectedWeek} from 'dummen-shared';

	defineProps<{
		productHeaders: Array<StaticTableHeader>;
		availabilityHeaders: Record<string, string>;
		tableSort: TableSort | null;
		selectedWeek: string | null;
	}>();

	const emit = defineEmits<(e: 'on-update-sort', sort: TableSort) => void>();

	const appStore = useAppStore();
	const filterStore = useFilters();

	const updateSelectedWeek = (week: string) => setSelectedWeek(week);

	const updateSort = async (sort: TableSort) => emit('on-update-sort', sort);

	const toggleFilters = () => {
		filterStore.collapseActiveFilter();
		appStore.toggleFilterBlock();
	};

</script>

<template>
	<FixedTableHeader
			:productHeaders="productHeaders"
			:tableSort="tableSort"
			table-class="catalog-overview-table--availability"
			@on-update-sort="updateSort"
			@on-toggle-filters="toggleFilters">

		<AvailabilityTableHeader v-for="[key, title] in Object.entries(availabilityHeaders)"
		                         :key="key"
		                         :isSelected="key === selectedWeek"
		                         :title="title"
		                         :value="key"
		                         @on-column-click="updateSelectedWeek" />

	</FixedTableHeader>
</template>
